import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, withDefaults } from 'vue';
import type VueI18n from 'vue-i18n/types';
interface Step {
  id?: string | number;
  label: string | VueI18n.TranslateResult;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'progression-stepper',
  props: {
    steps: { default: () => [] },
    modelValue: { default: 0 }
  },
  emits: ['update:modelValue', 'change'],
  setup(__props: any, { emit }) {

const props = __props as { steps: Step[], modelValue: number };

const IconCheck = () => import('@white-label-icon/icon-check');




const activeStep = ref(props.modelValue ?? 0);

watch(() => props.modelValue, (val) => {
  if (typeof val === 'number') activeStep.value = val;
});

function setActiveStep(idx: number) {
  if (idx !== activeStep.value) {
    activeStep.value = idx;
    emit('update:modelValue', idx);
    emit('change', idx);
  }
}

return { __sfc: true,IconCheck, props, emit, activeStep, setActiveStep }
}

})